<div class="loaderBg">
  <div class="loaderArea"></div>
</div>
